export const fileUploadByPresignedUrl = async (url, file, clientName)=>{
    const response = await fetch(url, {
        method: "PUT",
        headers: {
            "content-type": file.type,
            "x-amz-meta-clientname": clientName
        },
        body: file
    });
    return response;
};
